import { render, staticRenderFns } from "./LabelGroup.vue?vue&type=template&id=00135224&scoped=true&"
import script from "./LabelGroup.vue?vue&type=script&lang=js&"
export * from "./LabelGroup.vue?vue&type=script&lang=js&"
import style0 from "./LabelGroup.vue?vue&type=style&index=0&id=00135224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00135224",
  null
  
)

export default component.exports